/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-reset-cover.jpeg";
import {useRef, useState} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {Field} from "formik";
import OtpInput from "react-otp-input";
import {usePasswordResetMutation} from "../../../../store/api/account";
import {useSendOtpMutation} from "../../../../store/api/validation";
import {notificationActions} from "../../../../store/notification/notification-slice";
import {useDispatch} from "react-redux";

function ResetPassword() {
    const recaptchaRef = useRef();
    const [recaptchaToken, setRecaptchaToken] = useState();
    const [email, setEmail] = useState("");
    const [emailOtp, setEmailOtp] = useState("");
    const [isSended, setIsSended] = useState(false);
    const dispatch = useDispatch();
    const [resetPassword] = usePasswordResetMutation();
    const [sendOtp] = useSendOtpMutation();

    const resetHandler = async () => {
        if (!recaptchaToken) {
            dispatch(notificationActions.showMessage({
                message: "Please confirm Recaptcha",
                variant: "error"
            }));
            return;
        }

        dispatch(notificationActions.showLoading(true));
        const payload = await resetPassword({
            email: email,
            otp: emailOtp
        });
        if (payload?.data?.success) {
            dispatch(notificationActions.showMessage({
                message: `E-mail: ${payload?.data?.data}`,
                variant: "success"
            }));
            setIsSended(true);
        }
        if (payload?.error?.data) {
            dispatch(notificationActions.showMessage({
                message: `Email: ${payload?.error?.data?.detail}`,
                variant: "error"
            }));
            setIsSended(false);
        }
        dispatch(notificationActions.showLoading(false));


    }

    const sendOtpHandler = async () => {

        if (!recaptchaToken) {
            dispatch(notificationActions.showMessage({
                message: "Please confirm Recaptcha",
                variant: "error"
            }));
            return;
        }
        dispatch(notificationActions.showLoading(true));
        const payload = await sendOtp({
            destination: email,
            email
        });
        if (payload?.data?.success) {
            dispatch(notificationActions.showMessage({
                message: `EMail: ${payload?.data?.message}`,
                variant: "success"
            }));
            setIsSended(true);
        }
        if (payload?.error?.data) {
            dispatch(notificationActions.showMessage({
                message: `Email: ${payload?.error?.data?.detail}`,
                variant: "error"
            }));
            setIsSended(false);
        }
        dispatch(notificationActions.showLoading(false));

    };

    return (
        <CoverLayout coverHeight="50vh" image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    py={2}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
                        Reset Password
                    </MDTypography>
                    <MDTypography display="block" variant="button" color="white" my={1}>
                        You will receive an e-mail in maximum 60 seconds
                    </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">
                        <MDBox mb={4}>
                            <MDInput type="email" label="Email" variant="standard"
                                     onChange={(e) => setEmail(e.target.value)} fullWidth/>
                        </MDBox>
                        {isSended && (<MDBox mb={4}>
                            <MDTypography display="block" variant="button" color="black" my={1}>
                                OTP Code
                            </MDTypography>
                            <OtpInput onChange={(newValue) => setEmailOtp(newValue)}
                                      value={emailOtp}
                                      fullWidth
                                      numInputs={5}
                                      separator={<span>-</span>}
                                      isInputNum={true}/>
                        </MDBox>)}
                        <MDBox mb={4}>
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                style={{display: "inline-block"}}
                                sitekey="6LdZkOMiAAAAAF-8GfAqn60jZ5mwsGpv6c8vncob"
                                onChange={(value) => setRecaptchaToken(value)}
                                asyncScriptOnLoad={() => setRecaptchaToken(null)}
                            />
                        </MDBox>
                        <MDBox mt={6} mb={1}>
                            {isSended && (<MDButton disabled={!recaptchaToken || !emailOtp} variant="gradient"
                                                    color={"success"} onClick={resetHandler} fullWidth>
                                {"Confirm"}
                            </MDButton>)}
                            {!isSended && (<MDButton disabled={!recaptchaToken || !email} variant="gradient"
                                                    color={"error"} onClick={sendOtpHandler} fullWidth>
                                {"Reset"}
                            </MDButton>)}
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </CoverLayout>
    );
}

export default ResetPassword;
